import { Injectable } from '@angular/core';
import { DepartmentPickerItem } from '@data-managment/department-picker/shared/department-picker-item';
import { firstValueFrom, Subject } from 'rxjs';
import { OpenPopup } from './models/open-popup.model';

@Injectable({
  providedIn: 'root'
})
export class TreeCellDropdownService {
  private state$ = new Subject<OpenPopup>();

  private selectedDepartment$ = new Subject<DepartmentPickerItem>();

  public async getDepartment(request: OpenPopup) {
    this.showDropdown(request);

    return await firstValueFrom(this.selectedDepartment$);
  }

  public showDropdown(open: OpenPopup) {
    this.state$.next(open);
  }

  public observeDropdown() {
    return this.state$.asObservable();
  }

  public selectDepartment(selectedDepartment: DepartmentPickerItem | undefined) {
    this.selectedDepartment$.next(selectedDepartment);
  }
}
